import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ablToken, authanticatedUser, radomCharactors } from "../../../utils/helper";
import { syncClientInformation, updateClientUser } from "../../../redux/actions/users";
import * as types from "../../../redux/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRefresh
} from "@fortawesome/free-solid-svg-icons";

 const EditClientModal = ({ options }) => {
  const dispatch = useDispatch();
  const [clientNumber, setClientNumber] = useState('')
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [username, setUsername] = useState('')
  const [status, setStatus] = useState('')
  const { openEditClientModal, setOpenEditClientModal, clientData } = options;


  useEffect(() => {
    dispatch({ type: types.RESET_LOADING });
    setClientNumber(clientData?.clientNumber)
    setName(clientData?.name)
    setPhone(clientData?.phone)
    setUsername(clientData?.username)
    setStatus(clientData?.status)
  }, [clientData])

  const updateClientInfo = () => {
    const tmpData = {
      status,
      ablToken,
      id: clientData._id,
      token: authanticatedUser.token
    }

    dispatch(updateClientUser(tmpData))
    setOpenEditClientModal(false)
  }


  const syncClientInfo = () => {
    const tmpData = {
      ablToken,
      clientNumber: clientData.username,
      token: authanticatedUser.token
    }

    dispatch(syncClientInformation(tmpData))
    setOpenEditClientModal(false)
  }

  return (
    <Dialog
      open={openEditClientModal}
      onClose={setOpenEditClientModal}
      className="relative z-20"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 grid-cols-2 gap-4">
              <DialogTitle
                as="h3"
                className="text-lg mb-5 font-bold text-gray-900"
              >
                Update Client Information
              </DialogTitle>

              <div className="col-span-1">
                <label
                  htmlFor="clientNumber"
                  className="block text-sm font-bold text-gray-900"
                >
                  Client Name
                </label>
                <div className="mt-2">
                  <input
                    id="clientNumber"
                    name="clientNumber"
                    type="text"
                    value={name}
                    disabled={true}
                    autoComplete="Client Number"
                    onChange={e => setName(e.target.value)}
                    className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>

              <div className="col-span-1">
                <label
                  htmlFor="clientNumber"
                  className="block text-sm font-bold text-gray-900"
                >
                  Client Number
                </label>
                <div className="mt-2">
                  <input
                    id="clientNumber"
                    name="clientNumber"
                    type="text"
                    value={clientNumber}
                    disabled={true}
                    autoComplete="Client Number"
                    onChange={e => setClientNumber(e.target.value)}
                    className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>

              <div className="col-span-1">
                <label
                  htmlFor="phone"
                  className="block text-sm font-bold text-gray-900"
                >
                  Phone Number
                </label>
                <div className="mt-2">
                  <input
                    id="phone"
                    name="phone"
                    type="text"
                    value={phone}
                    disabled={true}
                    autoComplete="Client Number"
                    onChange={e => setPhone(e.target.value)}
                    className="block pl-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>

              <div className="col-span-1">
                <label
                  htmlFor="clientNumber"
                  className="block text-sm font-bold text-gray-900"
                >
                  Status
                </label>
                <div className="mt-2">
                <select id="status" onChange={e => setStatus(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                  <option value={status}>{status }</option>
                  {/* <option value={'approved'}  disabled={authanticatedUser?.accessModules[0]?.rights?.includes('approve') ? false : true} > Approve</option> */}
                  <option value={'disabled'} disabled={authanticatedUser?.accessModules[0]?.rights?.includes('edit') ? false : true}> Disable</option>
                  {/* <option value={'approved'} disabled={authanticatedUser?.accessModules[0]?.rights?.includes('edit') ? false : true}> Approve</option> */}
                </select>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row justify-between sm:px-6">
            <div
                className="mt-3 inline-flex w-full justify-left mr-20 rounded-md bg-blue-500 px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >
             
              </div>

              <div className="inline-flex justify-right">
                <button
                  type="button"
                  data-autofocus
                  onClick={() => setOpenEditClientModal(false)}
                  className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                >
                  Cancel
                </button>

                <button
                  type="button"
                  onClick={updateClientInfo}
                  className="inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 sm:ml-3 sm:w-auto"
                >
                  Update Client
                </button>
              </div>
              

              
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}


export default EditClientModal;